/**
 * Priorita masky: 1) user maska, 2) štandardná maska, 3) null (default columns).
 * Štandardná maska obsahuje len columns + attributes (žiadne filtre/triedenie).
 *
 * @param {string} page - názov stránky (napr. 'MaintenanceTypeList')
 * @param {object} state - redux state s user_mask_filters a standard_mask_filters
 * @returns {{ type: 'user'|'standard'|null, userMask?: object, standardMask?: object } | null}
 */
export function getEffectiveMask(page, state) {
  const userMask = (state.user_mask_filters || []).find((m) => m.page === page);
  if (userMask) {
    return { type: 'user', userMask };
  }
  const standardMask = (state.standard_mask_filters || []).find((m) => m.page === page);
  if (standardMask) {
    return { type: 'standard', standardMask };
  }
  return null;
}
